module.exports = __webpack_public_path__ + "static/img/iPadAir2.bc32fe8d.png";